import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Motion";
import { Seo } from "@/components/Seo";
import { SERVICES } from "@/data/services";
import { whatsappWithText } from "@/lib/site";
import { WhatsAppIcon } from "@/components/WhatsAppButton";

export default function ServicesPage() {
  return (
    <div data-testid="services-page">
      <Seo
        title="Academic Writing Services | MBA Project & Thesis Writing Help"
        description="MBA project help, thesis and dissertation writing, PhD assistance, research papers, law theses, and technical academic projects — all plagiarism-free with fixed quotes."
      />
      <PageHero
        eyebrow="Our services"
        lines={["Every format.", "Every discipline.", "One quality bar."]}
        sub="From a single essay to a complete doctoral thesis — pick the service that matches your requirement, or message us and we'll scope it for you."
      />
      <section className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {SERVICES.map((s, i) => (
            <Reveal key={s.slug} delay={(i % 2) * 0.08}>
              <Link
                to={`/services/${s.slug}`}
                data-testid={`services-list-card-${s.slug}`}
                className="group flex gap-6 h-full bg-white border border-slate-200 rounded-2xl p-8 transition-[box-shadow,border-color] duration-300 hover:shadow-xl hover:border-slate-300"
              >
                <s.icon className="h-8 w-8 text-[#2563EB] shrink-0" strokeWidth={1.5} />
                <div>
                  <h2 className="font-display font-bold text-xl tracking-tight">{s.name}</h2>
                  <p className="mt-2 text-sm text-slate-500 leading-relaxed">{s.short}</p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-medium text-[#1E2A78]">
                    View details
                    <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" strokeWidth={1.5} />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-16 border border-slate-200 rounded-2xl bg-[#F5F8FF] p-10 flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          <div>
            <h2 className="font-display font-bold text-2xl tracking-tight">Not sure which service fits?</h2>
            <p className="mt-2 text-slate-600">Describe your requirement and we'll recommend the right approach — free.</p>
          </div>
          <a
            href={whatsappWithText("Hi, I'm not sure which service I need. Can you help me decide?")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="services-page-whatsapp-cta"
            className="inline-flex items-center gap-2.5 rounded-full bg-[#25D366] px-7 py-3.5 text-sm font-semibold text-white transition-transform duration-200 hover:-translate-y-0.5 self-start"
          >
            <WhatsAppIcon className="h-5 w-5" /> Ask on WhatsApp
          </a>
        </Reveal>
      </section>
    </div>
  );
}
